import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2';

const widgetCmsService = {

    // Projetos
    listarProjetos: async (clienteId) => {
        const response = await axiosInstance.get(`${API_BASE}/clientes/${clienteId}/widget-projetos`);
        return response.data;
    },

    criarProjeto: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/clientes/${clienteId}/widget-projetos`, data);
        return response.data;
    },

    editarProjeto: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-projetos/${id}`, data);
        return response.data;
    },

    deletarProjeto: async (id) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-projetos/${id}/deletar`);
        return response.data;
    },

    vincularCanais: async (id, canalIds) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-projetos/${id}/canais`, { canalIds });
        return response.data;
    },

    // News
    listarNews: async (projetoId) => {
        const response = await axiosInstance.get(`${API_BASE}/widget-projetos/${projetoId}/news`);
        return response.data;
    },

    criarNews: async (projetoId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/widget-projetos/${projetoId}/news`, data);
        return response.data;
    },

    editarNews: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-news/${id}`, data);
        return response.data;
    },

    deletarNews: async (id) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-news/${id}/deletar`);
        return response.data;
    },

    // Help: categorias
    listarCategorias: async (projetoId) => {
        const response = await axiosInstance.get(`${API_BASE}/widget-projetos/${projetoId}/help-categorias`);
        return response.data;
    },

    criarCategoria: async (projetoId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/widget-projetos/${projetoId}/help-categorias`, data);
        return response.data;
    },

    editarCategoria: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-help-categorias/${id}`, data);
        return response.data;
    },

    deletarCategoria: async (id) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-help-categorias/${id}/deletar`);
        return response.data;
    },

    // Help: artigos
    listarArtigos: async (categoriaId) => {
        const response = await axiosInstance.get(`${API_BASE}/widget-help-categorias/${categoriaId}/artigos`);
        return response.data;
    },

    criarArtigo: async (categoriaId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/widget-help-categorias/${categoriaId}/artigos`, data);
        return response.data;
    },

    editarArtigo: async (id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-help-artigos/${id}`, data);
        return response.data;
    },

    deletarArtigo: async (id) => {
        const response = await axiosInstance.put(`${API_BASE}/widget-help-artigos/${id}/deletar`);
        return response.data;
    }
};

export default widgetCmsService;
